import { useQuery } from "@tanstack/react-query";

import { getSearchResultsService } from "@/services/search.service";
import { SearchParams, SearchResponse } from "@/types/search.types";

/** Below this the endpoint returns nothing, so there is no point asking. Keep
 *  in step with `MIN_QUERY` in `backend/routes/search.py`. */
export const MIN_SEARCH_LENGTH = 2;

export const searchQueryKeys = {
  all: () => ["search"] as const,
  results: (params: SearchParams) => [...searchQueryKeys.all(), params] as const,
};

/** Global (header) search. Pass an already-debounced query — this fires a
 *  request per distinct value. */
export const useGetSearchResults = (params: SearchParams = {}, { enabled = true } = {}) =>
  useQuery<SearchResponse, Error>({
    queryKey: searchQueryKeys.results(params),
    queryFn: () => getSearchResultsService(params),
    enabled: enabled && (params.q || "").toString().trim().length >= MIN_SEARCH_LENGTH,
    // Results are a navigation aid, not a live view: keeping the previous list
    // on screen while the next query resolves is what stops the dropdown
    // flickering empty between keystrokes.
    placeholderData: (previous) => previous,
    staleTime: 30_000,
  });
